import './App.scss';
import { Header } from './components/moleculas/header/Header';
import { InputForm } from './components/moleculas/inputform/InputForm2';
import { MultiForm } from './components/moleculas/multiform/Multiform';
import { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { modelSettings } from './settings/settings';
import { ModelSettings } from './components/moleculas/inputform/types';

function App() {
  const [activeTab, setActiveTab] = useState(1);
  const modelName = process.env.REACT_APP_MODEL_NAME;
  const currentModelSettings =
    modelName && (modelSettings[modelName] as ModelSettings);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabs = (
    <Tabs value={activeTab} onChange={handleTabChange} centered>
      <Tab label="About" />
      <Tab label="Run Model" />
      <Tab label="Contact" />
    </Tabs>
  );

  return (
    <>
      {modelName ? (
        <>
          <Header modelName={modelName} tabsPortal={tabs} />
          {currentModelSettings &&
            currentModelSettings.isContentMenuEnabled && (
              <Box sx={{ padding: 2, paddingBottom: 0 }}>
                {activeTab === 0 && (
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          (currentModelSettings &&
                            currentModelSettings.aboutContent) ||
                          '',
                      }}
                    />

                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          (currentModelSettings &&
                            currentModelSettings.readingContent) ||
                          '',
                      }}
                    />

                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          (currentModelSettings &&
                            currentModelSettings.eemdlContent) ||
                          '',
                      }}
                    />
                  </>
                )}
                {activeTab === 2 && (
                  <Typography variant="body1">
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          (currentModelSettings &&
                            currentModelSettings.contactContent) ||
                          '',
                      }}
                    />
                  </Typography>
                )}
              </Box>
            )}
          {activeTab === 1 && (
            <>
              {modelName === 'meet_pneumatics' ? (
                <MultiForm modelName={modelName} />
              ) : (
                <InputForm modelName={modelName} />
              )}
            </>
          )}
        </>
      ) : (
        <p>Incorrect model name</p>
      )}
    </>
  );
}

export default App;
